"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("./Text"));
var _Bubble = _interopRequireDefault(require("./Bubble"));
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param classes
 * @param first
 * @param second
 * @param handleChange
 * @param onBlur
 * @param third
 * @param text
 * @param isToggle
 * @param allowToggleOff
 * @param disabled
 * @returns {*}
 * @constructor
 */
var BubbleSelectBlock = function BubbleSelectBlock(_ref) {
  var _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle,
    first = _ref.first,
    second = _ref.second,
    handleChange = _ref.handleChange,
    onBlur = _ref.onBlur,
    _ref$third = _ref.third,
    third = _ref$third === void 0 ? {
      selected: false
    } : _ref$third,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? _i18n["default"].t(_tokens["default"].labels.or) : _ref$text,
    _ref$isToggle = _ref.isToggle,
    isToggle = _ref$isToggle === void 0 ? true : _ref$isToggle,
    _ref$allowToggleOff = _ref.allowToggleOff,
    allowToggleOff = _ref$allowToggleOff === void 0 ? false : _ref$allowToggleOff,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? false : _ref$label;
  var selectBlock = {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, selectBlock), customStyle)
  }, label && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    margin: "0 5px"
  }, label), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    disabledHover: disabled,
    label: first.title,
    isSelected: first.selected,
    onBlur: onBlur,
    customStyle: first.customStyle,
    clickable: !disabled,
    onClick: function onClick() {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(first.field, false);
        return null;
      }
      if (first.selected && !second.selected && !third.selected) {
        if (allowToggleOff) {
          handleChange(first.field, false);
        }
        return null;
      }
      if (second.selected) {
        handleChange(second.field, false);
      }
      if (third.selected) {
        handleChange(third.field, false);
      }
      handleChange(first.field, !first.selected);
      return null;
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    margin: "0 10px"
  }, text), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    disabledHover: disabled,
    label: second.title,
    isSelected: second.selected,
    onBlur: onBlur,
    customStyle: second.customStyle,
    clickable: !disabled,
    onClick: function onClick() {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(second.field, false);
        return null;
      }
      if (second.selected && !first.selected && !third.selected) {
        if (allowToggleOff) {
          handleChange(second.field, false);
        }
        return null;
      }
      if (first.selected) {
        handleChange(first.field, false);
      }
      if (third.selected) {
        handleChange(third.field, false);
      }
      handleChange(second.field, !second.selected);
      return null;
    }
  }), third.title && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    margin: "0 10px"
  }, _i18n["default"].t(_tokens["default"].labels.or)), /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    disabledHover: disabled,
    label: third.title,
    isSelected: third.selected,
    onBlur: onBlur,
    customStyle: third.customStyle,
    clickable: !disabled,
    onClick: function onClick() {
      if (disabled) {
        return null;
      }
      if (!isToggle) {
        handleChange(third.field, false);
        return null;
      }
      if (third.selected && !first.selected && !second.selected) {
        if (allowToggleOff) {
          handleChange(third.field, false);
        }
        return null;
      }
      if (first.selected) {
        handleChange(first.field, false);
      }
      if (second.selected) {
        handleChange(second.field, false);
      }
      handleChange(third.field, !third.selected);
      return null;
    }
  })));
};
var _default = exports["default"] = BubbleSelectBlock;